// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3A9RU","consentsList":"PatientConsents_consentsList__3dWdJ","consentsListEmpty":"PatientConsents_consentsListEmpty__3YiyT"};